var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "my-1",
                        attrs: {
                          variant: "primary",
                          to: "/servicetimesheet/add",
                        },
                      },
                      [_vm._v(" Add Timesheet ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "b-col",
                {
                  staticClass: "my-1",
                  attrs: { cols: "12", md: "2", sm: "2" },
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-col", { staticClass: "my-1", attrs: { sm: "10" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "outline-danger",
                          disabled: !_vm.anyFilterActive,
                        },
                        on: { click: _vm.clearFilters },
                      },
                      [_vm._v(" Clear Filters ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      items: _vm.filteredTimesheets,
                      fields: _vm.fields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "sort-changed": _vm.onSortChanged,
                      filtered: _vm.onFiltered,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "head(employeeID)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("User")]),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Filter by User",
                                      size: "sm",
                                    },
                                    on: { input: _vm.filterTable },
                                    model: {
                                      value: _vm.columnFilters.employeeName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "employeeName",
                                          $$v
                                        )
                                      },
                                      expression: "columnFilters.employeeName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "head(reference)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Reference")]),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Filter by Reference",
                                      size: "sm",
                                    },
                                    on: { input: _vm.filterTable },
                                    model: {
                                      value: _vm.columnFilters.reference,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "reference",
                                          $$v
                                        )
                                      },
                                      expression: "columnFilters.reference",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "head(date)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "column-header" },
                                [
                                  _c(
                                    "strong",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleSort("date")
                                        },
                                      },
                                    },
                                    [_vm._v("Appointment Date")]
                                  ),
                                  _c("date-picker", {
                                    staticClass: "mt-1 w-100",
                                    attrs: {
                                      range: true,
                                      format: "YYYY-MM-DD",
                                      placeholder: "Select Date Range",
                                      clearable: false,
                                      "input-attr": { readonly: true },
                                    },
                                    on: {
                                      change: _vm.filterTable,
                                      clear: function ($event) {
                                        $event.preventDefault()
                                        return _vm.preventClear($event)
                                      },
                                      focus: _vm.openCalendar,
                                    },
                                    model: {
                                      value: _vm.columnFilters.date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.columnFilters, "date", $$v)
                                      },
                                      expression: "columnFilters.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "head(status)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Status")]),
                                  _c("b-form-select", {
                                    staticClass: "mt-1",
                                    attrs: {
                                      options: _vm.statusOptions,
                                      size: "sm",
                                      placeholder: "Select Status",
                                    },
                                    on: { change: _vm.filterTable },
                                    model: {
                                      value: _vm.columnFilters.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "columnFilters.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "head(approvalDate)",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "column-header" },
                                [
                                  _c(
                                    "strong",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleSort("approvalDate")
                                        },
                                      },
                                    },
                                    [_vm._v("Approval Date")]
                                  ),
                                  _c("date-picker", {
                                    staticClass: "mt-1 w-100",
                                    attrs: {
                                      range: true,
                                      format: "YYYY-MM-DD",
                                      placeholder: "Select Approval Date Range",
                                      clearable: false,
                                      "input-attr": { readonly: true },
                                    },
                                    on: {
                                      change: _vm.filterTable,
                                      clear: function ($event) {
                                        $event.preventDefault()
                                        return _vm.preventClear($event)
                                      },
                                      focus: _vm.openCalendar,
                                    },
                                    model: {
                                      value: _vm.columnFilters.approvalDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "approvalDate",
                                          $$v
                                        )
                                      },
                                      expression: "columnFilters.approvalDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(employeeID)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getEmployee(data.item.employeeID)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    variant: "link",
                                    "toggle-class": "text-decoration-none",
                                    "no-caret": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("feather-icon", {
                                              staticClass:
                                                "text-body align-middle mr-25",
                                              attrs: {
                                                icon: "MoreVerticalIcon",
                                                size: "16",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm.checkPermissions(data.item)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.timesheetAction(
                                                "APPROVED",
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "CheckIcon" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "align-middle ml-50",
                                            },
                                            [_vm._v("Approve")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.checkPermissions(data.item)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.timesheetAction(
                                                "REJECTED",
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "XIcon" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "align-middle ml-50",
                                            },
                                            [_vm._v("Reject")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to:
                                          "/servicetimesheet/view/" +
                                          data.item.id,
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "EyeIcon" },
                                      }),
                                      _c("span", [_vm._v("View")]),
                                    ],
                                    1
                                  ),
                                  data.item.status === "PENDING" &&
                                  data.item.approverID === _vm.userId
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to:
                                              "/servicetimesheet/edit/" +
                                              data.item.id,
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "Edit2Icon" },
                                          }),
                                          _c("span", [_vm._v("Update")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2367201873
                    ),
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.timesheets.length == 0
                        ? _c(
                            "b-alert",
                            {
                              staticClass: "d-flex justify-content-center",
                              attrs: { variant: "warning", show: "" },
                            },
                            [
                              _c("h4", { staticClass: "alert-heading" }, [
                                _vm._v("No items found"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "mt-2",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }